module.exports = __webpack_public_path__ + "img/pauli-y-root-17.6fd825dd.svg";